export enum UIImageShapeType {
  ROUND = 'round',
  SQUARE = 'square'
}
